/* eslint-disable camelcase*/
/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import _, { isNull, isUndefined } from "lodash";
import moment from "moment";
import { CustomCheckbox, CheckMark } from "../CreateEvent/styles";

import {
  ContentWrapper,
  RsvpButton,
  // LayoutNew,
  IconContainer,
  InputImage,
  CommentsContainerNew,
  FormContainer,
  FieldContainer,
  CommentContent,
  PostButton,
  CommentInnerContainer,
  InputImage2,
  TopContainer,
  EventWrapperNewUI,
  AboutEventDiv,
  EventRightSectionRowMainDiv,
} from "./styles";
import { NoComments, ImageWrapper } from "../SocialFeeds/styles";
import AttendeesModal from "../AttendeesModal";
import Waiting from "../Waiting";
import Image from "../Image";
import Loading from "../Loading";
import { withRouter } from "react-router-dom";
// import RemoveAttendeesModal from "../RemoveAttendeesModal";
// import AddAttendeesModal from "../AddAttendeesModal";
import {
  SearchAttendeesForEvent,
  UpdateAttendeesList,
  attendLunchAndLearnEvent,
  getEventDetailsById,
} from "../../redux/actions/eventActions";
import {
  resetOrientation,
  getOrientation,
  checkImage,
  // convertHtmlToText,
  //convertMonthFromDate,
  timeConvertInHrsMins,
  fetchApi,
  // getTimeToShow
} from "../../utils/methods";
import { imageErrorMessage, ImageUrl, S3Url } from "../../utils/constants";
import { CommentContentContainer, /*HoverIconWrapper*/ } from "../ChallengeDetailsV2/styles";
import EventsComments from "../Comments/eventsComment";
import SocialFeedsEmojiPicker from "../SocialFeedsEmojiPicker";
import {
  // EventDetailsContainer,
  ContainerSecond,
  EventsButton,
  ContainerFirst,
  EventsButtonWrapper,
  EventCompletePoint,
} from "./styles";
import { convertDateInTimezone } from "../../utils/methods";
import { withTranslation } from "react-i18next";
import { updateUserGlobalPoints } from "../../redux/actions";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { ToolTipNew } from "../AdminTeamCreation/styles";
import { BuddyTabContainer, BuddyTab } from "../PeopleHomeV2/styles";
import { ReservedButton } from "../MainEvents/styles";
import AddInCalendar from "../AddInCalendar/calendarPopup";
import {
  StyledModal,
  CalendarWrapper,
  CalendarHeader,
  ConfirmVisitText,
  ButtonContainer,
  ButtonV2,
} from "../PeopleHomeV2/ManageBuddies/styles";
import InviteAmigoPopUp from "../ChallengeDetailsV2/InviteAmigoPopUp/inviteEvents";
import EventImageCard from "./eventImageCard";
import CommonTextArea from "../common/CommonTextArea/CommonTextArea";
import {
  RecognitionPencilIcon,
  NewPencilIcon,
  NewPlusIcon,
  NewBackArrowIconForEvents,
  TimeClockIcon,
  DatePickerIconUserEvents,
  LocationIcon,
  RewardPointsIcon,
  PeopleIconForRegisteredUsers,
  ViewIconForRegisteredUsers,
  EventFlyerIcon,
  EventDownloadIcon,
  AddUserIcon,
  NotificationIcon,
  // RemoveUserIcon,
  DeleteChallengeIcon,
  AddUsersIcon,
  AdminDownloadIcon,
  EventsAttendeesIcon,
  InviteChallengeIcon,
  
} from "../../utils/icons";
import { EventDetailsTitle } from '../EventDetails/styles';
import CoachProfile from "./CoachProfile";
import Timer from "./timer";
import EventVideoCard from "./eventVideoCard";
import { DeleteEventById, GetRegisteredAttendedReport, JoinOrLeaveThemeEvent, ModifyEventParticipants, SearchuserforEventInvite, SearchUserForEventRemove } from "../../redux/constants/apiConstants";
import parse from 'react-html-parser';
import HoverButton from "../common/HoverButtonV2";
import CustomNotification from "../ChallengeDetailsV2/customNotification";
// import { CommonButtonBorder } from "../common/commonStyles";
import AddUser from "../ChallengeDetailsV2/addUser";
import DeletePopup from "../DeletePostPopup/deletePopupBranding";
import UserInvitePopup from "../common/CommonCheckboxPopup/UserInvitePopup";
import CSVList from "../AttendeesModal/CSVList";
import EventMoments from "./EventMoments/EventMoments";
import { CommonButtonBorder } from "../common/commonStyles";
import { CommonButtonPopup } from "../ReportsV2/styles";

//import { CommonButton } from "../common/commonStyles";

const headers = [
  { label: "First Name", key: "fname" },
  { label: "Last Name", key: "lname" },
  { label: "Email", key: "EMAIL" },
  { label: "Company Name", key: "company_name" },
  {label: "Registered", key:'is_attending'},
  {label: "Attended", key:'is_attended'},
];

class EventDetails extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      showModal: "",
      comment: "",
      isAttending: 0,
      isUpdatedImage: false,
      refreshFileReader: false,
      imgSrc: [],
      messageLength: 0,
      showChatScreen: 0,
      displayEmoji: false,
      position: { start: 0, end: 0 },

      time: [],
      buttonStatus: 0,
      selectedTab: 1,
      eventEdit: false,
      eventDelete: false,
      showCalendar: false,
      showConfirmPopup: false,
      eventInvite: false,
      showInvitePopup: false,
      showBack: false,
      showSpinner: true,
      isButtonDisabled: false,
      addAttendees: false,
      registeredUser:false,
      editAttendees: false,
      hasCompanyInRoute: this.props.history.location.pathname.includes("/company/"),
      showCustomModel:false,
      popupType:"",
      inviteAmigosList: [],
      inviteLoading: false,
      userInviteList:[],
      page: 1,
      pageRemove: 1,
      limit: 20,
      invitePage: 1,
      inviteHasMore: true,
      isLoading: false,
      hasMore: true,
      hasMoreRemove:true,
      totalUsers: 0,
      totalUsersRemove:0,
      printAttendees:false,
      attendeesReportData:[],
      isCompanyPath:false,
      themeEventJoinLoading:false
    };
    this.emojiref = React.createRef();
  }
  


  searchEventUser = async (text, pageNo, reset = false) => {

    const { user, companyInfo, eventDetail } = this.props;
    const { page,userInviteList, isLoading, hasMore } = this.state;
  
    if (isLoading || !hasMore) return;
  
    const companyid = user?.company_id ? user?.company_id : companyInfo?.id;
  
    this.setState({ isLoading: true });
  
    try {
      const postData = {
        event_id: eventDetail?.id,
        search_name: text,
        page_no: reset ? pageNo : page,
        limit:20,
        type: "attended",
        company_id: companyid
      };
  
      const res = await fetchApi(SearchuserforEventInvite, "POST", postData, {});
  
      if (res?.message) {
        toast.error(res.message);
        this.setState({ userInviteList: [], isLoading: false, inviteHasMore: false });
        return;
      }
  
      const newUsers = res?.data?.user || [];
      const { current_page, total_pages, total_users } = res?.data?.pagination || {};
  
      this.setState({
        userInviteList:  reset ? newUsers : [...userInviteList, ...newUsers],
        page: current_page+1,
        inviteHasMore: current_page < total_pages,
        isLoading: false,
        totalUsers: total_users
      });
  
    } catch (error) {
      toast.error(error.message);
      this.setState({ isLoading: false });
    }
  };
  



  // searchEventUser = async (text) => {
  //   const { user, companyInfo,/* challengeId*/ eventDetail } = this.props;
  //   const companyid=user?.company_id?user?.company_id:companyInfo?.id;
  //   try {
  //     const postData = {
  //       "event_id" : eventDetail?.id,
  //       "search_name":text,
  //       "page_no": 1,
  //       "type": "attended",
  //       "limit": 10,
  //       company_id:companyid
  //     }; 
  //     const res = await fetchApi(
  //       SearchuserforEventInvite,
  //       "POST",
  //       postData,
  //       {},
  //     );
  //     if (res.message) {
  //       toast.error(res.message);
  //       this.setState({userInviteList:[]})
  //     }
  //     this.setState({userInviteList:res?.data?.list_data})
  //   } catch (error) {
  //     toast.error(error.message);
  //   }
  // };



  // searchRemoveEventUser = async (text) => {
  //   const { user, companyInfo,/* challengeId*/eventDetail } = this.props;
  //   const companyid=user?.company_id?user?.company_id:companyInfo?.id;
  //   try {
  //     const postData = {
  //       "event_id":eventDetail?.id,
  //       "search_name":text,
  //       "page_no": 1,
  //       "type": "attended",
  //       "limit": 10,
  //       company_id:companyid
  //     }; 
  //     const res = await fetchApi(
  //       SearchUserForEventRemove,
  //       "POST",
  //       postData,
  //       {},
  //     );

  //     if (res.message) {
  //       toast.error(res.message);
  //       this.setState({ inviteAmigosList: [] });
  //     }
  //     this.setState({ inviteAmigosList: res?.data?.list_data || [] })
     
  //   } catch (error) {
  //     toast.error(error.message);
  //   }
  // }


  searchRemoveEventUser = async (text, pageNo, reset = false) => {
    const { user, companyInfo, eventDetail } = this.props;
    const { pageRemove,inviteAmigosList, inviteLoading, hasMoreRemove } = this.state;
  
    // prevent duplicate calls
    if (inviteLoading || (!reset && !hasMoreRemove)) return;
  
    const companyid = user?.company_id ? user?.company_id : companyInfo?.id;
  
    this.setState({ inviteLoading: true });
  
    try {
      const postData = {
        event_id: eventDetail?.id,
        search_name: text,
        page_no:reset ? pageNo : pageRemove,
        type: "attended",
        limit: 20,
        company_id: companyid,
      };
  
      const res = await fetchApi(SearchUserForEventRemove, "POST", postData, {});
  
      if (res?.message) {
        toast.error(res.message);
        this.setState({
          inviteAmigosList: [],
          inviteLoading: false,
          hasMoreRemove: false,
        });
        return;
      }
  
      const newUsers = res?.data?.user || [];
      const { current_page, total_pages, total_users } = res?.data?.pagination || {};
  
      this.setState({
        inviteAmigosList: reset ? newUsers : [...inviteAmigosList, ...newUsers],
        pageRemove: current_page + 1,
        hasMoreRemove: current_page < total_pages,
        inviteLoading: false,
        totalUsersRemove: total_users,
      });
    } catch (error) {
      toast.error(error.message);
      this.setState({ inviteLoading: false });
    }
  };
  

  componentDidMount() {
    const isCompanyPath = this.props.location.pathname.includes("/company");
    this.setState({isCompanyPath:isCompanyPath})

    document.addEventListener("mousedown", this.handleEmojiClick);
    const {
      history: {
        location: { pathname },
      },
      fetchEventDetailsById,
      fetchCommentsOnEvent,
      getEventAttendees,
    } = this.props;
    const StringArray = pathname.split("/");
    if (StringArray[StringArray.length - 1] != "") {
      fetchEventDetailsById(StringArray[StringArray.length - 1]);
      fetchCommentsOnEvent(StringArray[StringArray.length - 1]);
      getEventAttendees(StringArray[StringArray.length - 1]);
    } else {
      fetchEventDetailsById(StringArray[StringArray.length - 2]);
      fetchCommentsOnEvent(StringArray[StringArray.length - 2]);
      getEventAttendees(StringArray[StringArray.length - 2]);
    }

    this.checkBase64(this.props.profileImage);
    // this.interval = setInterval(() => {
    //   this.setState({
    //     time: getTimeToShow(this.props.eventDetail, "event"),
    //   });
    // }, 1000);
    if (this.props.location.state === "chat") {
      this.setState({ selectedTab: 2 });
    }
    this.setState({
      hasCompanyInRoute: this.props.history.location.pathname.includes("/company/")
      
    })
  }

  componentDidUpdate(prevProps) {
    const {
      fetchEventDetailsById,
      location,
      fetchCommentsOnEvent,
      getEventAttendees,
    } = this.props;

    if (!this.state.showSpinner) {
      window.setTimeout(() => {
        this.setState({ showSpinner: true });
      }, 3000);
    }

    const StringArray = location.pathname.split("/");
    if (location.pathname !== prevProps.location.pathname) {
      if (StringArray[StringArray.length - 1] != "") {
        fetchEventDetailsById(StringArray[StringArray.length - 1]);
        fetchCommentsOnEvent(StringArray[StringArray.length - 1]);
        getEventAttendees(StringArray[StringArray.length - 1]);
      }
    }
    if (
      prevProps.eventDetail !== this.props.eventDetail ||
      prevProps.attending !== this.props.attending
    ) {
      this.setState(
        {
          isAttending: this.props.attending,
        },
        () => {
          this.chatScreenState();
        }
      );
    }
    // if (prevProps.eventDetail !== this.props.eventDetail) {
    //   clearInterval(this.interval);
    //   this.interval = setInterval(() => {
    //     this.setState({
    //       time: getTimeToShow(this.props.eventDetail, "event"),
    //     });
    //   }, 1000);
    // }
  }

  toCodePoints = function (string) {
    let chars = "";
    for (let i = 0; i < string.length; i++) {
      let c1 = string.charCodeAt(i);
      let b1 = string.charAt(i);
      if (c1 >= 0xd800 && c1 < 0xdc00 && i + 1 < string.length) {
        let c2 = string.charCodeAt(i + 1);
        if (c2 >= 0xdc00 && c2 < 0xe000) {
          chars =
            chars +
            ("&#" + (+0x10000 + ((c1 - 0xd800) << 10) + (c2 - 0xdc00)) + ";");
          i++;
          continue;
        }
      } else {
        chars = chars + b1;
      }
    }
    return chars;
  };

  checkBase64(profileImage) {
    if (profileImage) {
      let arr = profileImage.split("/");
      if (arr[0] !== "profile-Image") {
        this.setState({
          isUpdatedImage: true,
        });
      } else {
        this.setState({
          isUpdatedImage: false,
        });
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.profileImage != nextProps.profileImage) {
      this.checkBase64(nextProps.profileImage);
    }
  }

  componentWillUnmount() {
    document.addEventListener("mousedown", this.handleEmojiClick);
    // clearInterval(this.interval);
  }

  showProfileImage = () => {
    const { profileImage } = this.props;
    const { isUpdatedImage } = this.state;
    if (isUpdatedImage) {
      return (
        <img src={profileImage} alt="avatar" style={{ borderRadius: "50%" }} />
      );
    } else {
      return (
        <Image
          image={profileImage}
          alt="avatar"
          style={{ borderRadius: "50%" }}
        />
      );
    }
  };

  showAttendeesModal = (name) => {
    // const { SearchAttendeesForEvent, eventDetail } = this.props;
    this.setState({
      showModal: name,
    });
    if (name === "addAttendees") {
      // let obj = { event_id: eventDetail.id, name: "" };
      // SearchAttendeesForEvent(obj);
    }
  };

  hideAttendeesModal = () => {
    this.setState({
      showModal: "",
    });
  };

  onChange = (e) => {
    let position = this.getPosition(e.target);
    e.target.value !== " "
      ? this.setState({
        comment: e.target.value,
        position: position,
      })
      : null;
  };

  // downloadFLyer = (fileUrl) => {
  //   if(fileUrl){
  //     let fileInfo = fileUrl.split("/");
  //     const downloadLink = document.createElement("a");
  //     downloadLink.download = ImageUrl+"/"+fileUrl;
  //     downloadLink.target = '_blank';
  //     downloadLink.href = fileUrl;
  //     downloadLink.click();
  //   }
  // }

  // getSignedUrl = () => {
  //   const { bucketName, imagePath } = this.props;
  //   const params = {
  //     Bucket: bucketName,
  //     Key: imagePath,
  //     Expires: 60 // URL expiration time in seconds
  //   };
  //   const url = s3.getSignedUrl('getObject', params);
  //   this.downloadImage(url)
  //   // this.setState({ imageUrl: url });
  // }

  // downloadImage = async (imageUrl) => {

  //   try {
  //     const response = await fetch(imageUrl);
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = 'image.jpg'; // You can set the desired file name here
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //   } catch (error) {
  //     window.console.error('Error downloading the image', error);
  //   }
  // }



  handleSubmit = (uid) => {
    const {eventDetail, RemoveAttendees} = this.props;
  
    if (this.state.showModal === 'removeAttendees') {
      const obj = {
        event_id: eventDetail.id,
        user_id: uid,
        action_role: 'remove_event',
      };

      RemoveAttendees(obj, () => {
        toast.success( "Attendee removed successfully!");
      });
      // onClose(); 
      // const obj = {
      //   type:'user',
      //   event_id: eventDetail.id,
      //   ids: uid,
      //   action: 'remove',
      // };
      // this.EventAddRemoveUser(obj)
    } else {
      const obj = {
        event_id: eventDetail.id,
        user_id: uid,
        action_role: 'add_event',
      };
      // RemoveAttendees(obj);

      RemoveAttendees(obj, () => {
        toast.success("Attendee added successfully!");
      });
      // const obj = {
      //   type:'user',
      //   event_id: eventDetail.id,
      //   ids: uid,
      //   action: 'add',
      // };
      // this.EventAddRemoveUser(obj)
    }
  };

  EventAddRemoveUser = async(postData)=>{
    const { user, companyInfo, EventDetailsById, eventDetail } = this.props;
    const companyid=user?.company_id ? user?.company_id : companyInfo?.id;

    const res = await fetchApi(ModifyEventParticipants + '/' + companyid, "POST", postData);
    if(res.status === 'success'){
      toast.success(res?.data[0]);
      EventDetailsById(eventDetail.id);
    }

  }

  downloadFLyer = async (imageUrl) => {
    try {
      const response = await fetch(S3Url + "/" + imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "flyer"; // You can set the desired file name here
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      window.console.error("Error downloading the image", error);
    }
  };

  onChangeImage = (e) => {
    let file = e.target.files[0];
    this.setState({
      messageLength: e.target.value.length >= 1 ? "1" : "0",
    });
    if (checkImage(e.target.files)) {
      if (file?.size / 1000000 <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({
            imgSrc: [reader.result],
            refreshFileReader: true,
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrc: [baseImage],
                refreshFileReader: false,
              });
            });
          });
        };
      } else {
        toast.error("Please select image file less than 20MB");
        document.getElementById("uploadPhoto").value = "";
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById("uploadPhoto").value = "";
    }
  };

  removeImage = () => {
    this.setState({
      imgSrc: [],
      messageLength: 0,
    });
  };

  postComment = (e, id) => {
    const { postCommentOnEvent } = this.props;
    const { comment, imgSrc } = this.state;
    let html = this.toCodePoints(comment);
    postCommentOnEvent({
      event_id: id,
      comment: html,
      image: imgSrc.length >= 1 ? imgSrc[0] : "",
    });
    this.setState({
      comment: "",
      imgSrc: [],
      messageLength: 0,
    });
  };

  handleAttendEvent = () => {
    const { eventDetail, attendEvent } = this.props;
    const { isAttending } = this.state;
    attendEvent(eventDetail.id, isAttending, "eventDetail");
  };

  changeState = (value) => {
    this.setState({
      isAttending: value,
    });
  };

  showHideChatScreen = (status) => {
    this.setState({
      showChatScreen: status,
    });
  };

  renderAttendingView = () => {
    const { isAttending } = this.state;
    const { eventDetail } = this.props;
    const checkStartEvent =
      convertDateInTimezone(eventDetail.end_date)._d <= moment()._d ? 1 : 0;
    return (
      <ContentWrapper>
        <div>
          <span>Are you Attending?</span>
          <CustomCheckbox
            disabled={eventDetail.event_status === "over" || checkStartEvent}
          >
            {"I'm Attending"}
            <input
              type="checkbox"
              checked={isAttending === 1}
              onChange={() => this.changeState(1)}
              disabled={eventDetail.event_status === "over" || checkStartEvent}
            />
            <CheckMark checked={isAttending === 1} />
          </CustomCheckbox>
          <CustomCheckbox
            disabled={eventDetail.event_status === "over" || checkStartEvent}
          >
            Not Attending
            <input
              type="checkbox"
              checked={!isAttending}
              onChange={() => this.changeState(0)}
              disabled={eventDetail.event_status === "over" || checkStartEvent}
            />
            <CheckMark checked={!isAttending} />
          </CustomCheckbox>
          <RsvpButton
            disabled={eventDetail.event_status === "over" || checkStartEvent}
            onClick={() => this.handleAttendEvent()}
          >
            rsvp
          </RsvpButton>
        </div>
      </ContentWrapper>
    );
  };

  

  navigateEdit = () => {
    const { history, eventDetail } = this.props;
    const { pathname } = history.location;
    const StringArray = pathname.split("/");

    if(eventDetail?.is_lunch_and_learn_event){
      history.push(`/company/events/edit-lunch-learns/${StringArray[StringArray.length - 1]}`);

    }else{
      if (StringArray[StringArray.length - 1] != "") {
        history.push(`/company/events/${StringArray[StringArray.length - 1]}/edit`);
      } else {
        history.push(`/company/events/${StringArray[StringArray.length - 2]}/edit`);
      }

    }

  };

  showEmojiPicker = () => {
    this.setState((prev) => ({
      displayEmoji: !prev.displayEmoji,
    }));
  };

  hideEmojiPicker = () => {
    this.setState({
      displayEmoji: false,
    });
  };

  handleEmojiClick = (event) => {
    if (
      !isNull(this.emojiref) &&
      !isUndefined(this.emojiref) &&
      !(
        this.emojiref &&
        this.emojiref.current &&
        this.emojiref.current.contains(event.target)
      )
    ) {
      // this.setState({displayEmoji: false});
    }
  };

  onEmojiSelect = (emoji, id, native, skin) => {
    this.setState({
      emojiData: emoji,
      emojiId: id,
      emojiNative: native,
      emojiSkin: skin,
    });
    this.addInspirationV2(native);
  };

  getPosition(el) {
    let start = 0,
      end = 0,
      normalizedValue,
      range,
      textInputRange,
      len,
      endRange;

    if (
      typeof el.selectionStart == "number" &&
      typeof el.selectionEnd == "number"
    ) {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, "\n");
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd("character", -len);
            end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }
    return {
      start: start,
      end: end,
    };
  }

  addInspirationV2 = (e) => {
    let newText =
      this.state.comment.slice(0, this.state.position.start) +
      e +
      this.state.comment.slice(this.state.position.end);
    this.setState({
      position: {
        start: this.state.position.start + e.length,
        end: this.state.position.end + e.length,
      },
      comment: newText,
    });
  };

  fallBack = (e) => {
    e.target.src = "/public/images/default.png";
  };

  getEventStatus = () => {
    const { EventDetailsById, eventDetail } = this.props;
    EventDetailsById(eventDetail.id);
  };

  getEventAttendeesStatus(event, eventAttendees) {
    if (
      event.event_status === "over" ||
      convertDateInTimezone(event.end_date)._d <= moment()._d
    ) {
      return `${eventAttendees.length}  `;
    } else if (convertDateInTimezone(event.start_date)._d <= moment()._d) {
      return `${eventAttendees.length}`;
    } else {
      return `${eventAttendees.length} `;
    }
  }

  chatScreenState = () => {
    if (this.state.selectedTab === 2) {
      this.showHideChatScreen(2);
    }else {
      this.showHideChatScreen(0);
    }
  };

  setActiveTab = (active) => {
    this.setState(
      {
        selectedTab: active,
      },
      () => {
        this.chatScreenState();
      }
    );
  };

  showButton = () => {
    const { eventDetail } = this.props;
    this.handleEventAttending(eventDetail.id, eventDetail.is_attending);
    this.getEventStatus();
    this.setState({
      buttonStatus: !this.state.buttonStatus,
    });
  };

  handleEventAttending = (eventId, isAttending) => {
    this.props.attendEvent(eventId, isAttending);
  };

  // navigateEdit = () => {
  //   const { history } = this.props;
  //   const { pathname } = history.location;
  //   const StringArray = pathname.split("/");
  //   if (StringArray[StringArray.length - 1] != "") {
  //     history.push(`/events/${StringArray[StringArray.length - 1]}/edit`);
  //   } else {
  //     history.push(`/events/${StringArray[StringArray.length - 2]}/edit`);
  //   }
  // };

  eventButtonStatusHover = (value) => {
    if (value === "delete")
      this.setState({
        eventDelete: true,
      });
    else if (value === "invite") {
      this.setState({
        eventInvite: true,
      });
    } else if (value === "back") {
      this.setState({
        showBack: true,
      });
    } else {
      this.setState({
        eventEdit: true,
      });
    }
  };

  eventButtonStatus = (value) => {
    if (value === "delete")
      this.setState({
        eventDelete: false,
      });
    else if (value === "invite") {
      this.setState({
        eventInvite: false,
      });
    } else if (value === "back") {
      this.setState({
        showBack: false,
      });
    } else {
      this.setState({
        eventEdit: false,
      });
    }
  };

  calculateMinuits = (targetDate) => {
    let parsedDate1 = new Date(targetDate);
    let parsedDate2 = new Date();
    let difference = (difference = Math.abs(parsedDate2 - parsedDate1));
    if (difference <= 0) {
      return "Target date has already passed";
    }
    let days = Math.floor(difference / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    let showButton =
      days === 0 && hours === 0 && minutes > 0 && minutes < 31 ? true : false;
    return showButton;
  };

  showHideDeletePopup = () => {
    this.setState((prev) => ({ showConfirmPopup: !prev.showConfirmPopup }));
  };

  showHideInvitePopup = () => {
    this.setState((prev) => ({ showInvitePopup: !prev.showInvitePopup }));
  };

  deleteEvent = () => {
    this.setState(
      {
        showSpinner: false,
      },
      () => {
        this.deleteEventById(this.props.eventDetail.id);
      }
    );
  };

  deleteEventById = async(id) => {

    try {
      const res = await fetchApi(`${DeleteEventById}/${id}`, "DELETE");
      if(res.message) {
        toast.error(res.message);
      }
      else {
        toast.success(res?.data?.[0]);
        if(window.location.pathname.includes('company')){
          this.props.history.push("/company/dashboard");
        }else{
          this.props.history.push("/events");
          window.location.reload();
        }
        
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  confirmationPopup = () => {
    const { showConfirmPopup } = this.state;
    const { eventDetail } = this.props;
    return (
      <StyledModal show={showConfirmPopup} width={"485px"}>
        <CalendarHeader>
          <div>Delete Event</div>
        </CalendarHeader>
        <CalendarWrapper padding="0 25px 25px 25px">
          {
            <ConfirmVisitText>
              Are you sure you want to delete this Event?
            </ConfirmVisitText>
          }
          <ButtonContainer>
            <ButtonV2
              background="#007AB1"
              onClick={() => this.deleteEvent(eventDetail.id)}
            >
              {"Delete"}
            </ButtonV2>
            <ButtonV2
              border="1"
              background="transparent"
              color="#669db7"
              onClick={() => this.showHideDeletePopup()}
              style={{ border: "1px solid #669db7" }}
            >
              {"Cancel"}
            </ButtonV2>
          </ButtonContainer>
        </CalendarWrapper>
      </StyledModal>
    );
  };

  downloadAttendedUsers = async(isDownload)=>{

    if(isDownload){

      const res = await fetchApi(GetRegisteredAttendedReport + "/" + this.props.eventDetail.id);
      if(res.status === 'success'){
        this.setState({attendeesReportData:res?.data},()=>{
          this.setState({printAttendees:true})
        })
      }else{
        toast.error(res?.data?.message)
      }

    }else{
      this.setState({printAttendees:false});
    }

  }

  headerView = () => {
    const { /*eventDelete,*/ /*eventEdit,*/ selectedTab, /*eventInvite,*/ hasCompanyInRoute } =
      this.state;
    const {
      role, 
      /*addOrRemoveUserPermission,*/ eventDetail,
      userId /*isAdmin*/,
    } = this.props;
    let currentDate = new Date();
    let eventStartDate = new Date(eventDetail.start_date);
    let launchButton = false;
    if (currentDate > moment(convertDateInTimezone(eventStartDate)._d)) {
      launchButton = true;
    }
    let showLaunchButton =
      eventDetail && eventDetail.start_date
        ? this.calculateMinuits(
          moment(
            convertDateInTimezone(eventDetail && eventDetail.start_date)._d
          )
        )
        : null;
    // const allowAccess = isAdmin;
    const valid =
      Object.keys(eventDetail).indexOf("end_date") !== -1
        ? convertDateInTimezone(eventDetail.end_date)._d >= moment()._d
        : "";
    const popover = (value) => (
      <Popover
        id="popover-basic"
        style={{
          width: "auto",
          padding: "9px 14px",
          background: "#FFFFFF",
          border: "1px solid #005c87",
          boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
          borderRadius: "6px",
        }}
      >
        <div
          style={{
            fontFamily: "Rubik",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#005c87",
            textAlign: "center",
          }}
        >
          {value}
        </div>
      </Popover>
    );

    return (
      <BuddyTabContainer marginBottom="20px">
        <ToolTipNew
          margin={"auto 0px auto 0px"}
          height="40px"
          width="40px"
          transparent
        >
          <OverlayTrigger
            placement="bottom"
            overlay={popover(this.props.t("Back"))}
          >
            <div
              className='="toolTip'
              onClick={
                eventDetail.event_status === "over"
                  ? () => {
                    if(this.props.isAdminEvent){
                      if(window.location.pathname.includes('company')){
                        // this.props.history.push("/company/dashboard");
                        this.props.history.goBack();
                      }else{
                        this.props.history.push({pathname:"/events",state:"updateData"});
                      }
                    }else{
                      this.props?.location?.state?.view === "admin"
                        ? this.props.history.push({
                          pathname: `/company/events/completed`,
                        })
                        : this.props.history.push(`/events/completed`);

                    }
                  }
                  : () =>{ if(this.props.isAdminEvent){
                    if(window.location.pathname.includes('company')){
                      this.props.history.push("/company/events");
                      // this.props.history.goBack();
                    }else{
                      this.props.history.push({pathname:"/events",state:"updateData"});
                    }
                  }else if(this.props?.history?.location?.state?.fromDashboard){
                    this.props.history.push({
                      pathname: "/portal",state:"updateData"
                    })
                  }
                  else{
                    this.props.history.push({pathname:"/events",state:"updateData"});
                  }
                  }
              }
            >
              {/* <StyledSvgNew active={showBack} width="25px" height="25px">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <mask id="a" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
                    <path fill="#007AB1" d="M.645 0h24v24h-24z"/>
                  </mask>
                  <g mask="url(#a)">
                    <path d="M6.395 12c0-.358.15-.717.45-.99l9.428-8.6a1.64 1.64 0 0 1 2.172 0c.6.547.6 1.434 0 1.981L10.102 12l8.343 7.609c.6.547.6 1.434 0 1.98a1.64 1.64 0 0 1-2.172 0l-9.43-8.599a1.34 1.34 0 0 1-.448-.99" fill="#007AB1"/>
                  </g>
                </svg>
              </StyledSvgNew> */}
              <NewBackArrowIconForEvents/>
            </div>
          </OverlayTrigger>
        </ToolTipNew>
        {/* <BuddyTab
          active
        >
          {this.props.t("Event Brief")}
        </BuddyTab> */}
        <BuddyTab
          active={selectedTab === 1}
          onClick={() => this.setActiveTab(1)}
        >
          {this.props.t("Event Brief")}
        </BuddyTab>
        {eventDetail?.event_type === 'theme'? <BuddyTab
          active={selectedTab === 3}
          onClick={() => this.setActiveTab(3)}
        >
          {this.props.t("Moments")}
        </BuddyTab>:null}
        {eventDetail.is_attending === 1 ||
        (eventDetail.is_global_event === 0 && role === "WELLNESS_ADMIN") ? (
            <BuddyTab
              width
              padding
              active={selectedTab === 2}
              onClick={() => this.setActiveTab(2)}
              // style={{ color: '#005c87' }}
              margin={"10px 0px"}
            >
              {" "}
              {this.props.t("Chat")}
            </BuddyTab>
          ) : eventDetail.is_attending === 1 ||
            (eventDetail.is_global_event === 1 && role === "ADMIN") ? (
              <BuddyTab
                width
                padding
                active={selectedTab === 2}
                onClick={() => this.setActiveTab(2)}
                // style={{ color: '#005c87' }}
                margin={"10px 0px"}
              >
                {" "}
                {this.props.t("Chat")}
              </BuddyTab>
            ) : null}
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "12px", paddingRight: "20px"}}>   
          {(role === "ADMIN" ||
          eventDetail.created_by === userId ||
          (eventDetail.is_global_event == "0" && role === "WELLNESS_ADMIN")) &&
          eventDetail.event_status !== "over" && (
            !eventDetail.is_lunch_and_learn_event || 
    (eventDetail.is_lunch_and_learn_event === 1 && role === "ADMIN")) && eventDetail?.event_type != 'theme' &&   (

            <HoverButton
              title={this.props.t("Invite Buddies")}
              width="20px"
              height="20px"
              svgPath={<AddUserIcon/>} 
              onClick={this.showHideInvitePopup}
              backgroundColor={"white"}
              backgroundColorActive={"#DA6C74"}
              marginLeft={"0px"}
            />
          )}

          {(role === "ADMIN" ||
          eventDetail?.created_by === userId ||
          (role === "WELLNESS_ADMIN")) &&
          eventDetail?.event_status !== "over" 
            && eventDetail?.event_type === 'theme' &&  moment(convertDateInTimezone(eventDetail.start_date)._d) < new Date() &&  eventDetail?.event_join_status && this.state.isCompanyPath === true ? (

              <HoverButton
                title={this.props.t("Invite Buddies")}
                width="20px"
                height="20px"
                svgPath={<AddUserIcon/>} 
                onClick={this.showHideInvitePopup}
                backgroundColor={"white"}
                backgroundColorActive={"#DA6C74"}
                marginLeft={"0px"}
              />
            ) : null}

          {(role === "ADMIN" ||
          (eventDetail.created_by === userId && hasCompanyInRoute) ||
          (eventDetail.is_global_event === 0 && role === "WELLNESS_ADMIN" && hasCompanyInRoute)) && 
          valid &&
          eventDetail.event_status !== "over" &&
          !launchButton &&
          !showLaunchButton &&   (
            !eventDetail.is_lunch_and_learn_event || 
      (eventDetail.is_lunch_and_learn_event === 1 && role === "ADMIN")) &&   (
            <HoverButton
              title={this.props.t("Edit Event")}
              width="18px"
              height="20px"
              svgPath={<NewPencilIcon/>} 
              onClick={this.navigateEdit}
              backgroundColor={"white"}
              backgroundColorActive={"#DA6C74"}
              marginLeft={"0px"}
            />
          )}

          {((role==="ADMIN" ) || (role==="WELLNESS_ADMIN" && hasCompanyInRoute ) || (eventDetail.created_by === userId && hasCompanyInRoute  )) && eventDetail.event_status!="over" && 
          (<HoverButton
            title={this.props.t("Notification")}
            width="18px"
            height="20px"
            svgPath={<NotificationIcon/>} 
            onClick={() => this.setState({showCustomModel: true})}
            backgroundColor={"white"}
            backgroundColorActive={"#DA6C74"}
            marginLeft={"0px"}
          />)}
          {(role === "ADMIN" || 
           (eventDetail.created_by === userId && hasCompanyInRoute) ||
          (eventDetail.is_global_event == "0" && role === "WELLNESS_ADMIN" && hasCompanyInRoute)) &&
          eventDetail.event_status !== "over" && (
            !eventDetail.is_lunch_and_learn_event || 
      (eventDetail.is_lunch_and_learn_event === 1 && role === "ADMIN")) && (
            <HoverButton
              title={this.props.t("Delete Event")}
              width="20px"
              height="20px"
              svgPath={<DeleteChallengeIcon/>} 
              onClick={this.showHideDeletePopup}
              backgroundColor={"white"}
              backgroundColorActive={"#DA6C74"}
              marginLeft={"0px"}
              activeSvgPath={<DeleteChallengeIcon color={"white"}/>}
            />
          )}

          {((role==="ADMIN" ) || (hasCompanyInRoute )) && eventDetail.event_status ==="over" && 
          (<HoverButton
            fillOpacity={1}
            marginLeft="16px"
            svgPath={AdminDownloadIcon(24,24)} 
            activeColor={"#DA6C74"}
            inActiveColor={"#DA6C74"}
            backgroundColor={"rgba(254, 254, 254, 0.60)"}
            backgroundColorActive={"#DA6C74"}
            // width={'24px'}
            // height={'24px'}
            title={"Download"} onClick={()=>this.downloadAttendedUsers(true)} 
          />)}
        </div>
      </BuddyTabContainer>
    );
  };

  popover = (value) => (
    <Popover
      id="popover-basic"
      style={{
        width: "auto",
        padding: "9px 14px",
        background: "#FFFFFF",
        border: "1px solid #005c87",
        boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
        borderRadius: "6px",
      }}
    >
      <div
        style={{
          fontFamily: "Rubik",
          fontStyle: "normal",
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "20px",
          color: "#005c87",
          textAlign: "center",
        }}
      >
        {value}
      </div>
    </Popover>
  );

  showCalendarData = () => {
    this.setState((prev) => ({ showCalendar: !prev.showCalendar }));
  };

  hideCalendar = (id) => {
    this.setState(
      (prev) => ({ showCalendar: !prev.showCalendar, eventId: id }),
      () => {
        this.props.attendEvent(id, 0, 1);
      }
    );
  };


  showCalendar = (id, title, event) => {
    event.stopPropagation();
    this.setState((prev) => ({
      showCalendar: !prev.showCalendar,
      eventId: id,
      eventName: title,
    }));
  };

  hideCalendarAndReserve = (event) => {
    event.stopPropagation();
  };

  showHideCalendarLogic = () =>{
    this.setState((prev) => ({
      showCalendar: !prev.showCalendar,
    }));
  }

  // showCalendarAndReserve = (id, isAttending) => {
  //   if (isAttending !== 1) {
  //     this.setState((prev) => ({
  //       showCalendar: !prev.showCalendar,
  //     }));
  //   }
  //   this.setState(
  //     () => ({ eventId: id, isButtonDisabled: true }),
  //     () => {
  //       this.props.attendEventLimitUser(id, isAttending, this.showHideCalendarLogic);
  //       if (this.props.EventDetailsById) {
  //         this.props.EventDetailsById(id);
  //       }
  //     }
  //   );
  //   window.setTimeout(() => {
  //     this.setState({ isButtonDisabled: false });
  //   }, 2000);
  // };
  showCalendarAndReserve = (id, isAttending) => {
    if (isAttending !== 1) {
      this.setState((prev) => ({
        showCalendar: !prev.showCalendar,
      }));
    }
  
    this.setState({ eventId: id, isButtonDisabled: true }, async () => {
      await this.props.attendEventLimitUser(id, isAttending, this.showHideCalendarLogic);
      
      
      if (this.props.EventDetailsById) {
        this.props.EventDetailsById(id);
      }
  
      window.setTimeout(() => {
        this.setState({ isButtonDisabled: false });
      }, 2000);
    });
  };


  updateUserPoints = () => {
    const { eventDetail, attendLunchAndLearnEvent } = this.props;
    // const { isAttending } = this.state;
    attendLunchAndLearnEvent(eventDetail.id, 1,1, "eventDetail");
  };

  showOverviewSection = () => {
    const { eventDetail, t } = this.props;
    const { selectedTab } = this.state;

    return (
      <ContainerFirst width="100%" padding="0">
        {selectedTab === 1 && (eventDetail.is_lunch_and_learn_event && eventDetail.event_link && moment(convertDateInTimezone(eventDetail.start_date)._d) <= new Date() ?               
          <EventVideoCard event={eventDetail} updateUserPoints={this.updateUserPoints} isLunchAndLearn={true}/>
          : <EventImageCard event={eventDetail} />)}
        {selectedTab === 1 && (
          <>
            <AboutEventDiv>
              <div className="aboutTitle">
                {t("About the Event")}
              </div>
              <div className="aboutDescription">
                {parse(eventDetail.body)}
              </div>
            </AboutEventDiv>
          </>
        )}
      </ContainerFirst>
    );
  };
  convertMonthFromDate = (dateString) => {
    let temp = dateString.split(" ");
    temp[0] = this.props.t(temp[0]);
    temp = temp.join(" ");
    return temp;
  };

  onHideCustomNotification = () =>{
    this.setState({
      showCustomModel: false
    })
  }

  onHideAddUserPopup = () =>{
    this.setState({
      showAddUserPopup: false
    })
  }

  onAddUserPopup = (type, challenge) =>{
    this.setState({
      showAddUserPopup: true,
      popupType: type
    })
    if(challenge){
      this.setState({
        eventType: challenge
      })
    }
  }

  joinThemeEvent = async()=>{
    const{eventDetail,EventDetailsById}=this.props;
    const payload = {event_id:eventDetail.id,join_status:1};
    this.setState({themeEventJoinLoading:true})
    try{
      const res = await fetchApi(JoinOrLeaveThemeEvent, "POST",payload);
      if(res.status === "success"){
        // setWellnessChallengeList(res.data);
        toast.success(res?.message)
        EventDetailsById(eventDetail.id);
        this.setState({themeEventJoinLoading:false})
      }else{
        toast.error(res.message);
        this.setState({themeEventJoinLoading:false})
      }
    }catch(error){
      toast.error(error);
      this.setState({themeEventJoinLoading:false})
    }finally{
      this.setState({themeEventJoinLoading:false})
    }
  }


  render() {

    
    
    const {
      userId,
      eventDetail,
      networkError,
      isLoading,
      attendees,
      // attending,
      isAdmin,
      // addOrRemoveUserPermission,
      comments,
      replySuccess,
      postReplyOnComment,
      printEventCsvPermission,
      // history,
      t,
      role,
      // attendEvent,
      addOrRemoveUserPermission,
      allRoles
    } = this.props;

    // const isSuperAdminAndAdmin = allRoles?.some(
    //   (data) => [3,12].includes(data?.rid)
    // );

    const path = window.location.pathname; 
    const parts = path.split("/").filter(Boolean); 
    const hasCompany = parts.includes("company");
    // const isWellnessAdmin = allRoles?.some((role) => role.rid === 12);


    const hasAnyRole = allRoles?.some(
      (data) => [12].includes(data?.rid)
    );
    const {
      comment,
      showModal,
      imgSrc,
      showChatScreen,
      messageLength,
      selectedTab,
      showCalendar,
      showInvitePopup,
      showSpinner,
      addAttendees,
      editAttendees,
      isButtonDisabled,
      showCustomModel,
      showAddUserPopup,
      eventType,
      popupType,
      // inviteAmigosList,
      // userInviteList,
      printAttendees,
      attendeesReportData
    } = this.state;


    if (
      ((_.isNull(eventDetail) ||
        _.isUndefined(eventDetail) ||
        _.isEmpty(eventDetail) ||
        _.isNull(attendees)) &&
        !networkError) ||
      !showSpinner
    ) {
      return <Waiting />;
    }
    const allowAccess = isAdmin;
    // let today = new Date();
    // let startDate = new Date(eventDetail.start_date);
    //const lang = localStorage.getItem("lang");

    
    // const preSelected = inviteAmigosList?.filter((u) => u.is_invited)?.map((u) => u.friend_id);

    // const preUserSelected = userInviteList?.filter((u) => u.is_invited)?.map((u) => u.friend_id);

    const shouldShowViewIcon =
     eventDetail?.attended_count > 0 &&
     eventDetail.event_status === "over" &&
     (
       role === "ADMIN" ||
       (eventDetail.is_global_event == "0" && addOrRemoveUserPermission) || this.state.hasCompanyInRoute
     ) ;

    const isMoment = true;


    return (
      <>
        <div className="containerDiv" style={{marginTop:"40px"}}>
          {this.headerView()}
        </div>
        {selectedTab === 1 && (
          <EventDetailsTitle
            style={{
              width: "1248px",
              margin: "20px auto"
            }}
          >
            {eventDetail.title}
          </EventDetailsTitle>
        )}
        
        {/* <EventDetailsTitle style={{marginTop: "20px", marginBottom: "20px", marginLeft: "65px"}}>{eventDetail.title}</EventDetailsTitle> */}
        {isMoment && selectedTab === 3 &&<div style={{width:"1248px",margin:"auto auto 40px auto"}}> 
          {selectedTab === 3 && <EventMoments event={eventDetail} getEventDetailsById={this.props.EventDetailsById} userId={userId} history={this.props.history}/>}
        </div>}
        {isMoment && selectedTab != 3 && <div style={{display:"flex",width:"1248px",margin:"auto auto 40px auto", background:"white", padding:"20px", borderRadius: '12px',
          border:' 0.75px solid #DCDCDC'}}>
          <div className="leftContainer" style={{minWidth:"750px", maxWidth:"750px"}}>
            {selectedTab === 1 && this.showOverviewSection()}
            {showModal === "attendees" && <AttendeesModal
              Title={t(eventDetail.title)}
              Attendees={attendees}
              showModal={showModal === "attendees"}
              onHide={this.hideAttendeesModal}
              isValidUser={printEventCsvPermission}
              role={role}
              eventType={eventDetail.is_global_event}
              eventId={eventDetail.id}
              type={'attended'}
              isCompanyUsers={eventDetail?.company_attended != null}
            />}
            {showModal === "registeredUser" && <AttendeesModal
              Title={t(eventDetail.title)}
              Attendees={attendees}
              showModal={showModal === "registeredUser"}
              onHide={this.hideAttendeesModal}
              isValidUser={printEventCsvPermission}
              role={role}
              eventType={eventDetail.is_global_event}
              isRegisteredUserPopup={true}
              eventId={eventDetail.id}
              type={'registered'}
              isCompanyUsers={eventDetail?.company_registered != null}
            /> }
            {/* {allowAccess && (
              <RemoveAttendeesModal
                Attendees={attendees}
                showModal={showModal === "removeAttendees"}
                onHide={this.hideAttendeesModal}
                eventIdValue={eventDetail.id}
              />
            )} */}


            {/* {allowAccess && (
              <AddAttendeesModal
                eventId={eventDetail.id}
                title={t("Add Attendees")}
                subContent="The searched users will be add to the attendees list"
                showModal={showModal === "addAttendees"}
                onHide={this.hideAttendeesModal}
              />
            )} */}


            {/* {allowAccess && showModal === "removeAttendees" && (
              <UserInvitePopup
                show={showModal === "removeAttendees"}
                onHide={this.hideAttendeesModal}
                title="Remove User"
                userList={inviteAmigosList}
                // preSelected={preSelected}
                loading={this.state.inviteLoading}
                onSearch={this.searchRemoveEventUser}
                onSubmit={this.handleSubmit}
                t={this.props.t}
                buttonText={t("Remove")}
                searchText={"Who would you like to remove?"}
                isRemoveMode
              />
            )}
            
 */}
            {allowAccess && showModal === "removeAttendees" && (
              <UserInvitePopup
                show={showModal === "removeAttendees"}
                onHide={this.hideAttendeesModal}
                title="Remove User"
                userList={this.state.inviteAmigosList}
                loading={this.state.inviteLoading}
                page={this.state.pageRemove || 1}
                hasMore={this.state.hasMoreRemove ?? true}
                onSearch={this.searchRemoveEventUser}
                onSubmit={this.handleSubmit}
                t={this.props.t}
                buttonText={t("Remove")}
                searchText={"Who would you like to remove?"}
                isRemoveMode
              />)}
            
            {allowAccess && showModal === "addAttendees" && (
              <UserInvitePopup
                show={showModal === "addAttendees"}
                onHide={this.hideAttendeesModal}
                title="Add User"
                userList={this.state.userInviteList}
                loading={this.state.inviteLoading}
                onSearch={this.searchEventUser}
                page={this.state.invitePage}
                t={this.props.t}
                hasMore={this.state.inviteHasMore}
                onSubmit={this.handleSubmit}
                buttonText={t("Add")}
                searchText={"Who would you like to add?"}
                isAddMode={true}
              />)}


            {/* {allowAccess && showModal === "addAttendees" && (
              <UserInvitePopup
                show={showModal === "addAttendees"}
                onHide={this.hideAttendeesModal}
                title="Add User"
                userList={userInviteList}
                // preSelected={preUserSelected}
                loading={this.state.inviteLoading}
                onSearch={this.searchEventUser}
                onSubmit={this.handleSubmit}
                t={this.props.t}
                buttonText={t("Add")}
                searchText={"Who would you like to add?"}
                isAddMode={true}
              />
            )} */}

            {showChatScreen ? (
              <CommentsContainerNew>
                <FormContainer margin={1} editChallenge>
                  <TopContainer>
                    <h3 style={{ color: "#005c87" }}>{t("Chat Group")}</h3>
                    <div>
                      {attendees.length > 0 && (
                        <img
                          src={`${ImageUrl}/${attendees[0].profile_image}`}
                        />
                      )}
                      {attendees.length > 1 && (
                        <img
                          src={`${ImageUrl}/${attendees[1].profile_image}`}
                        />
                      )}
                      {attendees.length > 2 && (
                        <img
                          src={`${ImageUrl}/${attendees[2].profile_image}`}
                        />
                      )}
                      {attendees.length > 3 && (
                        <img
                          src={`${ImageUrl}/${attendees[3].profile_image}`}
                        />
                      )}
                      {attendees.length > 4 && (
                        <img
                          src={`${ImageUrl}/${attendees[4].profile_image}`}
                        />
                      )}
                      {attendees.length > 5 && (
                        <div>{attendees.length - 5}+</div>
                      )}
                    </div>
                  </TopContainer>
                  <CommentContentContainer>
                    {eventDetail.event_status === "over" ? null : (
                      <FieldContainer>
                        <CommentContent>
                          <ImageWrapper
                            isCommentSection
                            borderRadius={"3px"}
                          >
                            {this.showProfileImage()}
                          </ImageWrapper>
                          <CommentInnerContainer style={{ border: "none" }}>
                            <div
                              style={{
                                width: "470px",
                                background: "#faf9f4",
                                border: "1px solid #afcbd3",
                                color: "#005c87",
                                borderRadius: "20px",
                              }}
                            >
                              {imgSrc &&
                                imgSrc.length >= 1 &&
                                messageLength && (
                                <InputImage2 className="InputImageSection">
                                  <img src={imgSrc} alt="uploadable" />
                                  <button onClick={this.removeImage}>
                                    <span className="InputImageSpan">
                                      X
                                    </span>
                                  </button>
                                </InputImage2>
                              )}
                              <CommonTextArea
                                placeholder={t(
                                  "Write your comment here..."
                                )}
                                onChange={(e) => this.onChange(e)}
                                value={comment}
                                rows={comment.length >= 120 ? "5" : "2"}
                                data-gramm_editor="false"
                                showEmojiPicker={this.showEmojiPicker}
                                onClick={(e) => this.onChange(e)}
                                style={{
                                  marginTop: "0px",
                                  display: "flex",
                                  alignItems: "center",
                                  background: "#faf9f4",
                                  border: "none",
                                  borderRadius: "20px",
                                  color: "#005c87",
                                  float: "inherit",
                                  padding: "14px 15px",
                                  paddingTop:
                                    comment.length == "" ? "20px" : "10px",
                                  paddingBottom:
                                    comment.length == "" ? "5px" : "10px",
                                  placeholderColor: "#649bb3",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                marginLeft: "15px",
                                position: "relative",
                              }}
                            >
                              {this.state.displayEmoji ? (
                                <SocialFeedsEmojiPicker
                                  selectEmoji={this.onEmojiSelect}
                                  emojiRef={this.state.emojiRef}
                                  hidePicker={this.hideEmojiPicker}
                                />
                              ) : null}
                              <IconContainer
                                cameraIcon
                                style={{
                                  marginLeft: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: "4px",
                                }}
                              >
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={this.popover(
                                    this.props.t("Emoji")
                                  )}
                                >
                                  <img
                                    style={{
                                      marginLeft: "15px",
                                      cursor: "pointer",
                                      width: "46px",
                                      height: "46px",
                                    }}
                                    onClick={this.showEmojiPicker}
                                    src={
                                      ImageUrl +
                                      "/images/new_emoji_icon.png"
                                    }
                                  ></img>
                                </OverlayTrigger>
                                <InputImage
                                  htmlFor="uploadPhoto"
                                  noMarginTop
                                  style={{
                                    background: "none",
                                    padding: "0px",
                                  }}
                                >
                                  <OverlayTrigger
                                    placement="bottom"
                                    overlay={this.popover(
                                      this.props.t("Attach photo")
                                    )}
                                  >
                                    <img
                                      src={
                                        ImageUrl +
                                        "/images/new_camera_icon.png"
                                      }
                                      style={{
                                        marginLeft: "10px",
                                        cursor: "pointer",
                                        width: "46px",
                                        height: "46px",
                                      }}
                                    />
                                  </OverlayTrigger>
                                  <input
                                    id="uploadPhoto"
                                    type="file"
                                    name={t("image")}
                                    accept=".jpeg, .png, .jpg*"
                                    multiple={false}
                                    onChange={(e) => this.onChangeImage(e)}
                                    onClick={(e) =>
                                      e.target.files[0] &&
                                      this.onChangeImage(e)
                                    }
                                  />
                                </InputImage>
                              </IconContainer>
                            </div>
                          </CommentInnerContainer>
                        </CommentContent>
                        {comment || imgSrc.length >= 1 ? (
                          <PostButton
                            style={{ background: "#005c87" }}
                            color="#159fc9"
                            onClick={(e) =>
                              this.postComment(e, eventDetail.id)
                            }
                          >
                            {t("Post")}{" "}
                            <img src="/public/images/SendPost.svg" />
                          </PostButton>
                        ) : null}
                      </FieldContainer>
                    )}
                    {isLoading ? (
                      <Loading isHorizontal />
                    ) : _.isEmpty(comments) ? (
                      <NoComments isEventChatComment={true}>
                        {t("No comments to display")}
                      </NoComments>
                    ) : (
                      <EventsComments
                        comments={comments}
                        fixHeight
                        replySuccess={replySuccess}
                        postReply={postReplyOnComment}
                        id={eventDetail.id}
                        isChallengeOrEvent={true}
                      />
                    )}
                  </CommentContentContainer>
                </FormContainer>
              </CommentsContainerNew>
            ) : null}
          </div>
          <div className="rightContainer" style={{minWidth:"400px", marginLeft:"20px"}}>
            <ContainerSecond width="100%">
              {eventDetail.event_status === "notover" ? (
                <div>
                  {eventDetail.is_attended &&
                  eventDetail.event_status === "over" ? (
                      <EventCompletePoint
                        backgroundColor={"white"}
                        cursor={"1"}
                        color="#005c87"
                        style={{ marginBottom: "25px" }}
                      >
                        <div className="wrapper" style={{ color: "#005c87" }}>
                          <div className="text">You earned </div>&nbsp;
                          <div className="point" style={{ color: "#76AB78" }}>
                            +{eventDetail.event_points} Social Points{" "}
                          </div>
                          &nbsp; for
                        </div>
                        <div className="wrapper" style={{ color: "#005c87" }}>
                          participating!
                        </div>
                      </EventCompletePoint>
                    ) : null}
                  {eventDetail.is_attended ? (
                    <EventsButton
                      color={"#005c87"}
                      cursor={"1"}
                      shadow="none"
                      style={{
                        marginBottom: "25px",
                        border: "1px solid #005c87",
                      }}
                    >
                      {t("You Attended")}
                    </EventsButton>
                  ) : (
                    <EventsButton
                      color="#f4aaa9"
                      cursor={"1"}
                      style={{ marginBottom: "25px" }}
                      shadow="none"
                    >
                      {t("You did not attend")}
                    </EventsButton>
                  )}
                  {/* <EventsButton
											backgroundColor={"rgba(156, 156, 156, 0.1)"}
											color={"rgb(253, 113, 117)"}
											cursor={"1"}
											shadow="none"
										>
											{t("This Event Has Ended")}
										</EventsButton> */}
                  <EventsButtonWrapper>
                    {((role === "ADMIN" &&
                        eventDetail.event_status === "over") ||
                        (eventDetail.is_global_event == "0" &&
                          addOrRemoveUserPermission &&
                          eventDetail.event_status === "over")) && (
                      <EventsButton
                        width={"1"}
                        color={"#007AB1"}
                        style={{
                          border: "1px solid #007AB1",
                          background: addAttendees && "#007AB1",
                          color: addAttendees && "white",
                        }}
                        onClick={() =>
                          this.showAttendeesModal("addAttendees")
                        }
                        onMouseEnter={() =>
                          this.setState({ addAttendees: true })
                        }
                        onMouseLeave={() =>
                          this.setState({ addAttendees: false })
                        }
                      >
                        <span style={{ marginRight: "12px" }}>
                          {
                            <NewPlusIcon
                              fill={addAttendees ? "white" : "#007AB1"}
                            />
                          }
                        </span>{" "}
                        {t("Invite Buddies")}
                      </EventsButton>
                    )}
                    {((role === "ADMIN" &&
                        eventDetail.event_status === "over") ||
                        (eventDetail.is_global_event == "0" &&
                          addOrRemoveUserPermission &&
                          eventDetail.event_status === "over")) && (
                      <EventsButton
                        width={"1"}
                        color={"#007AB1"}
                        style={{border:"1px solid #007AB1", background:editAttendees && "#007AB1", color:editAttendees && "white"}}
                        onClick={() =>
                          this.showAttendeesModal("removeAttendees")
                        }
                        onMouseEnter={() => this.setState({ editAttendees: true })}
                        onMouseLeave={() => this.setState({ editAttendees: false })}
                      >
                        <span style={{marginRight:"12px"}}>{<NewPencilIcon fill={editAttendees ? "white" : "#007AB1"}/>}</span>{t("Edit Attendees")}
                      </EventsButton>
                    )}
                  </EventsButtonWrapper>
 
                  <AboutEventDiv style={{background:"white",borderRadius:"6px",padding:"12px"}}>
                    <div className="aboutTitle" style={{marginTop:"0px",marginBottom:"16px"}}>
                      About the Event
                    </div>
                    <div className="aboutDescription" style={{width:"unset", fontFamily:"Rubik-Regular",lineHeight:"24px"}}>
                      {parse(eventDetail.body)}
                    </div>
                  </AboutEventDiv>
                </div>
              ) : (
                <div>
                  <div className="topLabelDiv">
                    <div className="label blueLabel" style={{minWidth:"160px"}}>
                      {eventDetail?.event_type ? this.props.t(eventDetail?.event_type) + " Event"  : eventDetail.is_lunch_and_learn_event === 1 ? this.props.t("Lunch and Learn")  : eventDetail.is_global_event=="1"?this.props.t("Woliba Live Event"): this.props.t("Company Live")}
                    </div>
                    { (eventDetail?.event_status != "over" && moment(convertDateInTimezone(eventDetail.start_date)._d) > new Date()) && (<div className="label" style={{minWidth:"260px"}}>
                      <Timer data={moment(convertDateInTimezone(eventDetail.start_date)._d)}/>
                    </div>)}

                    { (eventDetail?.event_status != "over" && moment(convertDateInTimezone(eventDetail.start_date)._d) < new Date()) && eventDetail?.event_type === 'theme' && (<div className="label" style={{minWidth:"260px"}}>
                      <Timer data={moment(convertDateInTimezone(eventDetail.end_date)._d)} startText={'Ends in :'}/>
                    </div>)}

                    {eventDetail?.is_attended && eventDetail?.event_status === "over"?<div className="label blueLabel">
                      <img src={ImageUrl + "/images/emoji/happy-emoji.svg"}/>&nbsp;You attended
                    </div>:
                      eventDetail?.event_status === "over"&&<div className="label redLabel">
                        <img src={ImageUrl + "/images/emoji/sad-emoji.svg"}/>You did not attend 
                      </div>}
                  </div>
                  {
                    selectedTab === 1 && (
                      <EventWrapperNewUI  isRow={true}>
                        {/* {eventDetail.event_status !== "over" && (
                          <div className="buttonContainer" style={{ display: "flex", gap: "16px" }}>
                            {
                             
                              !eventDetail.is_attending ? (
                                <ReservedButton
                                  width="100%"
                                  active={true}
                                  onClick={
                                    isButtonDisabled
                                      ? null
                                      : (event) =>
                                        this.showCalendarAndReserve(
                                          eventDetail.id,
                                          eventDetail.is_attending,
                                          eventDetail.title,
                                          event
                                        )
                                  }
                                >
                                  {t("Reserve Spot")}
                                </ReservedButton>
                              ) : (
                                <>
                                  {eventDetail.add_to_calendar === 0 ? (
                                    <ReservedButton
                                      active={true}
                                      onClick={(event) =>
                                        this.showCalendar(eventDetail.id, eventDetail.title, event)
                                      }
                                    >
                                      {t("Add to Calendar")}
                                    </ReservedButton>
                                  ) : (
                                    // <ReservedButton
                                    //   active={false}
                                    //   style={{
                                    //     background: "rgba(0, 122, 177, 0.10)",
                                    //     color: "rgba(0, 122, 177, 0.30)",
                                    //     border: 'none',
                                    //     cursor: "not-allowed",
                                    //   }}
                                    // >
                                    //   <div className="icon"><RightIcon fillOpacity={0.3} fill={"#007AB1"}/></div>
                                    //   {t("Add to Calendar")}
                                    // </ReservedButton>
                                    <ReservedButton
                                      active={true}
                                      onClick={(event) =>
                                        this.showCalendar(eventDetail.id, eventDetail.title, event)
                                      }
                                    >
                                      {t("Add to Calendar")}
                                    </ReservedButton>
                                  )}
                                  <ReservedButton
                                    active={false}
                                    onClick={
                                      isButtonDisabled
                                        ? null
                                        : (event) =>
                                          this.showCalendarAndReserve(
                                            eventDetail.id,
                                            eventDetail.is_attending,
                                            eventDetail.title,
                                            event
                                          )
                                    }
                                  >
                                    {t("Cancel Reservation")}
                                  </ReservedButton>
                                </>
                              )
                            }
                          </div>
                        )} */}
                        {eventDetail?.event_type === 'theme' && moment(convertDateInTimezone(eventDetail.start_date)._d) < new Date() && !eventDetail?.event_join_status  && eventDetail?.event_status !== "over" ?                                 
                          <CommonButtonPopup
                            width="100%"
                            active={true}
                            onClick={this.joinThemeEvent}
                            disabled={this.state.themeEventJoinLoading}
                            background={'#DA6C74'}
                          >
                            {t("Join Event")} </CommonButtonPopup>:null}
                        {eventDetail.event_status !== "over" && eventDetail?.event_type != 'theme' && (
                          <div className="buttonContainer" style={{ display: "flex", gap: "16px" }}>
                            {selectedTab === 1 &&
                              moment(convertDateInTimezone(eventDetail.start_date)._d) < new Date() &&
                              eventDetail.event_location === null &&
                              eventDetail.is_attending === 1 ? (
                                
                                <a
                                  href={eventDetail.event_encrypted_link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ width: "100%", textDecoration: "none" }}
                                >
                                  <ReservedButton active={true} width="100%">
                                    {t("Join Event")}
                                  </ReservedButton>
                                </a>
                              ) : !eventDetail.is_attending ? (
                                
                                <ReservedButton
                                  width="100%"
                                  active={true}
                                  onClick={
                                    isButtonDisabled
                                      ? null
                                      : (event) =>
                                        this.showCalendarAndReserve(
                                          eventDetail.id,
                                          eventDetail.is_attending,
                                          eventDetail.title,
                                          event
                                        )
                                  }
                                >
                                  {t("Reserve Spot")}
                                </ReservedButton>
                              ) : (
                                
                                <>
                                  <ReservedButton
                                    active={true}
                                    onClick={(event) =>
                                      this.showCalendar(eventDetail.id, eventDetail.title, event)
                                    }
                                  >
                                    {t("Add to Calendar")}
                                  </ReservedButton>
                          
                                  <ReservedButton
                                    active={false}
                                    onClick={
                                      isButtonDisabled
                                        ? null
                                        : (event) =>
                                          this.showCalendarAndReserve(
                                            eventDetail.id,
                                            eventDetail.is_attending,
                                            eventDetail.title,
                                            event
                                          )
                                    }
                                  >
                                    {t("Cancel Reservation")}
                                  </ReservedButton>
                                </>
                              )}
                          </div>
                        )}

                        
                        

                          


                        <EventRightSectionRowMainDiv>
                          <div className="imageDiv">
                            {DatePickerIconUserEvents()} 
                          </div>
                          {/* <div className="details">
                            <div>
                              { (lang !== 'fr') ? (convertMonthFromDate(moment(convertDateInTimezone(eventDetail && eventDetail.start_date)._d).format("ddd, MMM DD, YYYY"), this.props)) : convertMonthFromDate(moment(convertDateInTimezone(eventDetail && eventDetail.start_date)._d).format("ddd, DD MMM YYYY"), this.props)}
                              &nbsp; | &nbsp;
                              {moment(
                                convertDateInTimezone(eventDetail.start_date)._d
                              ).format("hh:mm a")} 
                            </div>
                            
                            {!eventDetail.is_all_day_event ? (<div>
                              { (lang !== 'fr') ? (convertMonthFromDate(moment(convertDateInTimezone(eventDetail && eventDetail.end_date)._d).format("ddd, MMM DD, YYYY"), this.props)) : convertMonthFromDate(moment(convertDateInTimezone(eventDetail && eventDetail.end_date)._d).format("ddd, DD MMM YYYY"), this.props)}
                              &nbsp; | &nbsp;
                              {moment(
                                convertDateInTimezone(eventDetail.end_date)._d
                              ).format("hh:mm a")}{" "}
                              ({eventDetail.abbreviation})
                            </div>):null}
                          </div> */}
                          {eventDetail?.event_type == 'theme' ? <div className="detail" style={{display:'flex'}}>
                            
                            <div>
                              {this.convertMonthFromDate(
                                moment(
                                  convertDateInTimezone(
                                    eventDetail?.start_date
                                  )._d
                                ).format("MMM D")
                              )} {" - "}
                            </div>
                            {!eventDetail.is_all_day_event && (
                              <div>
                                { moment(
                                  convertDateInTimezone(
                                    eventDetail?.end_date
                                  )._d
                                ).format(
                                  " MMM D, YYYY"
                                )}
                              </div>
                            )}
                          </div> :<div className="detail">
                            
                            <div>
                              {this.convertMonthFromDate(
                                moment(
                                  convertDateInTimezone(
                                    eventDetail?.start_date
                                  )._d
                                ).format("MMM D, YYYY | hh:mm A")
                              )} {eventDetail?.abbreviation}
                            </div>
                            {!eventDetail.is_all_day_event && (
                              <div>
                                {moment(
                                  convertDateInTimezone(
                                    eventDetail?.end_date
                                  )._d
                                ).format(
                                  "MMM D, YYYY | hh:mm A"
                                )} {eventDetail?.abbreviation}
                              </div>
                            )}
                          </div>}

                        </EventRightSectionRowMainDiv>
 
                        {eventDetail?.event_type != 'theme' && <EventRightSectionRowMainDiv>
                          <div className="imageDiv">
                            {TimeClockIcon()}
                          </div>
                          <div className="details">
                            <div>
                              {eventDetail.is_all_day_event ? "1 Day" : timeConvertInHrsMins(Math.floor((moment(eventDetail.end_date)).diff(moment(eventDetail.start_date), 'minutes')))}
                            </div>
                          </div>
                        </EventRightSectionRowMainDiv>}
 
 
                        {eventDetail.event_location && eventDetail?.event_type != 'theme' ? (
                          <EventRightSectionRowMainDiv>
                            <div className="imageDiv">
                              {LocationIcon()}
                            </div>
                            <div className="details">
                              <div>{t("Onsite Event")} | {t(eventDetail.event_location)}</div>
                            </div>
                          </EventRightSectionRowMainDiv>) 
                          : 
                          eventDetail?.event_type != 'theme' ? 
                            <EventRightSectionRowMainDiv>
                              <div className="imageDiv">
                                {LocationIcon()}
                              </div>
                              <div className="details">
                                <div>{t("Virtual Event")}</div>
                              </div>
                            </EventRightSectionRowMainDiv>
                            : null
                        }
 
                        {eventDetail?.event_points>0 && eventDetail?.event_type != 'theme' ?<EventRightSectionRowMainDiv>
                          <div className="imageDiv">
                            {(RewardPointsIcon())}
                          </div>
                          <div className="details">
                            <div> +{eventDetail.event_points} {t("pts")}</div>
                          </div>
                        </EventRightSectionRowMainDiv>:null}

                        {eventDetail?.event_points>0 && eventDetail?.event_type === 'theme' ?<EventRightSectionRowMainDiv>
                          <div className="imageDiv">
                            {(RewardPointsIcon())}
                          </div>
                          <div className="details">
                            <div> +{eventDetail?.event_points} {t("participation points")}</div>
                          </div>
                        </EventRightSectionRowMainDiv>:null}

                        {eventDetail?.moment_points>0 && eventDetail?.event_type === 'theme' ?<EventRightSectionRowMainDiv>
                          <div className="imageDiv">
                            {(RewardPointsIcon())}
                          </div>
                          <div className="details">
                            <div> +{eventDetail.moment_points} {t("moment posting points")}</div>
                          </div>
                        </EventRightSectionRowMainDiv>:null}

                        {eventDetail?.event_participants_count>0 && eventDetail?.event_type === 'theme' ?<EventRightSectionRowMainDiv>
                          <div className="imageDiv">
                            <PeopleIconForRegisteredUsers />
                          </div>
                          <div className="details">
                            <div> {eventDetail.event_participants_count} {t(`joined user${eventDetail.event_participants_count > 1 ? "s" : ""}` )}</div>
                          </div>
                        </EventRightSectionRowMainDiv>:null}
 
                        {eventDetail?.attendees_count > 0?<EventRightSectionRowMainDiv>
                          <div className="imageDiv">
                            {(PeopleIconForRegisteredUsers())}
                          </div>
                          <div className="details">
                            <div style={{display:'flex', alignItems:"center"}}>
                              <div>
                                {eventDetail?.attendees_count > 0 ? eventDetail?.attendees_count + " Registered Users": "None"}
                                {eventDetail?.company_registered != null  && (eventDetail.is_lunch_and_learn_event === 1 || eventDetail.is_global_event=="1") ? <>{" "}(<span>{(eventDetail?.company_registered)} company</span>)</> : null }
                              </div>
                              {eventDetail?.attendees_count > 0  ?<span
                                className="eye"
                                onClick={() => {this.showAttendeesModal("registeredUser")}} >
                                {ViewIconForRegisteredUsers('#DA6C74')}
                              </span>:null}
                            </div>
                          </div>
                        </EventRightSectionRowMainDiv>:null}
 
                        {eventDetail.is_lunch_and_learn_event && !eventDetail.event_location ? null : (
                          (!eventDetail.event_location ||
                            moment(convertDateInTimezone(eventDetail.end_date)._d) < new Date()) && (
                            // if role is USER, only show if attendees > 0
                            !hasCompany ? (
                              eventDetail?.attended_count > 0 && (
                                <EventRightSectionRowMainDiv>
                                  <div className="imageDiv">{EventsAttendeesIcon()}</div>
                                  <div className="details">
                                    <div className="attendesSectionMainDiv">
                                      <div>
                                        {eventDetail.attended_count + " Attendees "}
                                        {eventDetail?.company_attended ? (
                                          <>
                                            {" "}
                                            (<span>{eventDetail.company_attended} Company</span>)
                                          </>
                                        ) :null}
                                      </div>
                                      <div className="attendeeDiv">
                                        {shouldShowViewIcon && (
                                          <span
                                            className="eye"
                                            onClick={() => {
                                              this.showAttendeesModal("attendees");
                                            }}
                                          >
                                            {ViewIconForRegisteredUsers()}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </EventRightSectionRowMainDiv>
                              )
                            ) : (
                              // for company users / admins
                              (eventDetail?.attended_count > 0 || eventDetail.event_status === "over") && (
                                <EventRightSectionRowMainDiv>
                                  <div className="imageDiv">{EventsAttendeesIcon()}</div>
                                  <div className="details">
                                    <div className="attendesSectionMainDiv">
                                      <div>
                                       
                                        {eventDetail.event_status === "over" ? (
                                          eventDetail.attended_count === 0 ? (
                                            "None"
                                          ) : (
                                            `${eventDetail.attended_count} Attendees `
                                          )
                                        ) : eventDetail.attended_count > 0 ? (
                                          `${eventDetail.attended_count} Attendees `
                                        ) : null}
                                      
                                        {eventDetail?.company_attended ? (
                                          <>
                                            (<span>{eventDetail?.company_attended} Company</span>)
                                          </>
                                        ) : null }
                                      
                                      
                                      </div>
                                      <div className="attendeeDiv">
                                        {shouldShowViewIcon && (
                                          <span
                                            className="eye"
                                            onClick={() => {
                                              this.showAttendeesModal("attendees");
                                            }}
                                          >
                                            {ViewIconForRegisteredUsers()}
                                          </span>
                                        )}
                        
                                        {((role === "ADMIN" && eventDetail.event_status === "over") ||
                                          (eventDetail.is_global_event == "0" &&
                                             addOrRemoveUserPermission &&
                                             eventDetail.event_status === "over") ||
                                           (eventDetail.is_global_event == "0" &&
                                             hasAnyRole &&
                                             eventDetail.event_status === "over")) &&
                                           this.state.hasCompanyInRoute && (
                                          <>
                                            <span
                                              onClick={() => {
                                                this.showAttendeesModal("removeAttendees");
                                              }}
                                            >
                                              {RecognitionPencilIcon()}
                                            </span>
                                            <span
                                              onClick={() => {
                                                this.showAttendeesModal("addAttendees");
                                              }}
                                            >
                                              {AddUsersIcon()}
                                            </span>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </EventRightSectionRowMainDiv>
                              )
                            )
                          )
                        )}

                        { eventDetail?.event_type === 'theme' ? 
                          <>
                            <div className="theme-event-point">All points will be credited once the event concludes.</div>

                            {moment(convertDateInTimezone(eventDetail.start_date)._d) < new Date()  && eventDetail?.event_status !== "over" && eventDetail?.event_join_status && (this.state.isCompanyPath === false) ? 
                              <CommonButtonBorder margin={"28px 0px 0px 0px"} width={'100%'} onClick={this.showHideInvitePopup}> {InviteChallengeIcon('#DA6C74')}
                                Invite Friends
                              </CommonButtonBorder>: null}
                          </>:null}



                        {/* {eventDetail.is_lunch_and_learn_event && !eventDetail.event_location ? null : (
                          ( !eventDetail.event_location ||
                          moment(convertDateInTimezone(eventDetail.end_date)._d) < new Date()
                          ) && (
                            // if role is USER, only show if attendees > 0
                            !hasCompany
                              ? eventDetail?.attended_count > 0 && (
                                <EventRightSectionRowMainDiv>
                                  <div className="imageDiv">
                                    {EventsAttendeesIcon()}
                                  </div>
                                  <div className="details">
                                    <div className="attendesSectionMainDiv">
                                      <div>
                                        {eventDetail.attended_count + " Attendees"}
                                        {eventDetail?.company_attended && (
                                          <>
                                            {" "}
                                              (<span>{eventDetail.company_attended} company</span>)
                                          </>
                                        )}
                                      </div>
                                      <div className="attendeeDiv">
                                        {shouldShowViewIcon && (
                                          <span
                                            className="eye"
                                            onClick={() => {
                                              this.showAttendeesModal("attendees");
                                            }}
                                          >
                                            {ViewIconForRegisteredUsers()}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </EventRightSectionRowMainDiv>
                              )
                              : (
                                <EventRightSectionRowMainDiv>
                                  <div className="imageDiv">
                                    {(EventsAttendeesIcon())}
                                  </div>
                                  <div className="details"> 
                                    <div className="attendesSectionMainDiv">
                                      <div>
                                        {eventDetail && eventDetail?.attended_count && eventDetail.attended_count > 0 ? eventDetail.attended_count + " Attendees": "None"} 
                                        {eventDetail?.company_attended ? <>{" "}(<span>{(eventDetail?.company_attended)} company</span>)</> : null }
                                      </div>
                                      <div className="attendeeDiv">
                                        {shouldShowViewIcon && <span
                                          className="eye"
                                          onClick={() => {this.showAttendeesModal("attendees")}} >
                                          {ViewIconForRegisteredUsers()}
                                        </span>}
                                        {((role === "ADMIN" && eventDetail.event_status === "over") || (eventDetail.is_global_event=="0" && addOrRemoveUserPermission && eventDetail.event_status === "over") || (eventDetail.is_global_event=="0" && hasAnyRole && eventDetail.event_status === "over")) &&  this.state.hasCompanyInRoute &&
                                                          <span onClick={ () => {this.showAttendeesModal("removeAttendees");}} >{RecognitionPencilIcon()}</span>}
                                                            
                                        {((role === "ADMIN" && eventDetail.event_status === "over") || (eventDetail.is_global_event=="0" && addOrRemoveUserPermission && eventDetail.event_status === "over") || (eventDetail.is_global_event=="0" && hasAnyRole && eventDetail.event_status === "over")) && this.state.hasCompanyInRoute && (
                                          <span onClick={ () => {this.showAttendeesModal("addAttendees"); }}>{AddUsersIcon()}</span>)}
                                      </div>
                                    </div>
                                  </div>
                                </EventRightSectionRowMainDiv>)
                            
                          ))} */}
                        {eventDetail?.event_flyer?<EventRightSectionRowMainDiv>
                          <div className="imageDiv">
                            <EventFlyerIcon/>
                          </div>
                          <div className="details eventFlyer">
                            <span>Event Flyer</span>
                            {eventDetail.event_flyer ? (
                              <span
                                className="iconButton"
                                onClick={() => {
                                  this.downloadFLyer(eventDetail.event_flyer);
                                }}
                              >
                                <EventDownloadIcon/>
                              </span>
                            ) : (
                              <span>Not Available</span>
                            )}
                          </div>
                        </EventRightSectionRowMainDiv>:null}
                        {/* {allowAccess && moment(convertDateInTimezone(eventDetail.start_date)._d) > new Date() && this.state.hasCompanyInRoute ?<HoverIconWrapper justify="space-between" margin="28px 0 0 0">
                          <CommonButtonBorder style={{marginRight:'12px'}} onClick={eventDetail.is_team_event?()=>this.onAddUserPopup('Add', 'team'):  ()=>this.onAddUserPopup('Add')}>{AddUserIcon()}{eventDetail.is_team_event?"Add Team":"Add User"}</CommonButtonBorder>
                          <CommonButtonBorder onClick={eventDetail.is_team_event?()=>this.onAddUserPopup('Remove', 'team'):()=>this.onAddUserPopup('Remove')}>{RemoveUserIcon()}{eventDetail.is_team_event?"Remove Team": "Remove User"}</CommonButtonBorder>
                        </HoverIconWrapper>:null} */}
                      </EventWrapperNewUI>
                    )}
                </div>
              )}
              {/* {selectedTab === 1 && (eventDetail.event_status != "over" && moment(convertDateInTimezone(eventDetail.start_date)._d) < new Date() && !eventDetail.event_location) ? 
                (<a
                  href={eventDetail.event_encrypted_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  { <CommonButton width={"100%"} style={{background:"#007AB1"}}>Join Now</CommonButton> }
                  <ReservedButton
                    active={true}
                    width="100%"
                  >
                    {t("Join Now")}
                  </ReservedButton>
                  
                </a>) : null}  */}

              {showCalendar && (
                <AddInCalendar
                  show={showCalendar}
                  closeModal={this.showCalendarData}
                  event={eventDetail}
                  width={"100%"}
                  margin={"0%"}
                  hideCalendar={this.hideCalendar}
                />
              )}
              {/* {this.confirmationPopup()} */}
              {this.state.showConfirmPopup && 
              <DeletePopup                
                showModal={this.state.showConfirmPopup}
                onClose={this.showHideDeletePopup}
                deleteConsumer={this.deleteEvent}
                type="event"/>}
              {showInvitePopup && (
                <InviteAmigoPopUp
                  history={this.props.history}
                  showModal={showInvitePopup}
                  onHide={this.showHideInvitePopup}
                  eventId={eventDetail.id}
                  plusAmigoButton={1}
                  userId={this.props.userId}
                />
              )}
            </ContainerSecond>
          </div>
        </div>}
        {selectedTab === 1 && eventDetail?.coach_id && (<div style={{ marginTop: "40px", marginBottom: "80px", display:"flex",justifyContent:"center" }}>
          <CoachProfile coachDetail={eventDetail?.coach_details} history={this.props.history}  AdminView={this.props?.location?.state?.view}/>
        </div>)}
        {showCustomModel&&<CustomNotification onClose={this.onHideCustomNotification} showModal={showCustomModel} id={eventDetail.id} type='event'/>}
        {showAddUserPopup && <AddUser onClose={this.onHideAddUserPopup} showModal={showAddUserPopup} challengeId={eventDetail.id} type={popupType} challengeType={eventType} companyInfo={this.props.companyInfo} module={'event'} getEventAttendees={this.props.getEventAttendees}/>}
        {printAttendees &&
          <CSVList Title={`${eventDetail.title}_Event_Attendees`} removeCSVData={this.downloadAttendedUsers} data={attendeesReportData} headers={headers} />
        }
      </>
    );
  }
}

EventDetails.propTypes = {
  history: PropTypes.object.isRequired,
  fetchEventDetailsById: PropTypes.func.isRequired,
  eventDetail: PropTypes.object,
  fetchCommentsOnEvent: PropTypes.func.isRequired,
  comments: PropTypes.array,
  isLoading: PropTypes.bool,
  postCommentOnEvent: PropTypes.func.isRequired,
  postReplyOnComment: PropTypes.func.isRequired,
  replySuccess: PropTypes.string,
  profileImage: PropTypes.string,
  attendEvent: PropTypes.func.isRequired,
  getEventAttendees: PropTypes.func.isRequired,
  attendees: PropTypes.array,
  attending: PropTypes.number.isRequired,
  isAdmin: PropTypes.bool,
  userId: PropTypes.number,
  location: PropTypes.object,
  SearchAttendeesForEvent: PropTypes.func,
  role: PropTypes.string,
  addOrRemoveUserPermission: PropTypes.bool,
  printEventCsvPermission: PropTypes.bool,
  EventDetailsById: PropTypes.func.isRequired,
  t: PropTypes.func,
  networkError: PropTypes.string,
  updateUserGlobalPoints: PropTypes.func,
  attendLunchAndLearnEvent: PropTypes.func,
  isAdminEvent: PropTypes.bool,
  attendEventLimitUser: PropTypes.func,
  companyInfo:PropTypes.object,
  allRoles:PropTypes.array,
  user: PropTypes.object,
  RemoveAttendees: PropTypes.func,
};




const mapStateToProps = (state) => ({
  eventDetail: state.events.eventDetail,
  comments: state.events.comments,
  attendees: state.events.attendees,
  attending: state.events.attending,
  isLoading: state.events.isLoading,
  userId: state.profileData.userId,
  allRoles: state.profileData.allRoles,
  companyInfo: state.companyDashboard.companyInfo,
  user: state.profileData.user,
  
});

const mapDispatchToProps = (dispatch) => ({
  SearchAttendeesForEvent: (data) => dispatch(SearchAttendeesForEvent(data)),
  EventDetailsById: (id) => dispatch(getEventDetailsById(id)),
  updateUserGlobalPoints: (actionId, activityType, callBackForUpdaingApiDetails) => dispatch(updateUserGlobalPoints(actionId, activityType, callBackForUpdaingApiDetails)),
  attendLunchAndLearnEvent: (eventId, isAttending,isAttended) => dispatch(attendLunchAndLearnEvent(eventId, isAttending, isAttended)),
  RemoveAttendees: (data,onSuccess) => dispatch(UpdateAttendeesList(data,onSuccess))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EventDetails))
);
